// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2PTwC","inputWrap":"CustomTip_inputWrap__3U-ha"};